<template>
  <router-view></router-view>
</template>
<style lang="less" type="text/less"></style>
<script>
export default {
  name: 'CommonView',
  created () {
    this.judgeRedirect()
  },
  methods: {
    // 1. 判断是否需要重定向
    judgeRedirect () {
      const path = this.$route.path
      console.log(path)
      const reg = /^\/space\/database\/((inventory)|(combination)|(quota)|(material))\/?/
      const matchArr = reg.exec(path) || []
      console.log(matchArr)
      if (matchArr.length > 1) {
        // 清单数据、组价数据、定额数据、人材机数据 相关页面 重定向到
        // /iframe/encodeURIComponent(linkUrl)/encodeURIComponent(菜单名称)?linkUrl=encodeURIComponent(linkUrl)&t=1604303248421
        // linkUrl 是数据拆分后 数据相关页面独立项目 完整的url地址
        let menuName = ''
        switch (matchArr[1]) {
          case 'inventory':
            menuName = '清单数据'
            break
          case 'quota':
            menuName = '定额数据'
            break
          case 'combination':
            menuName = '组价数据'
            break
          case 'material':
            menuName = '人材机数据'
            break
          default:
        }
        let iframeUrl = window.location.href
        if (iframeUrl.indexOf('/#') && menuName) {
          iframeUrl = iframeUrl.substring(0, iframeUrl.indexOf('/#'))
          iframeUrl += '/bigdata/#' + path
          iframeUrl = iframeUrl.replace('zjy-gray.glodon.com', 'zjy.glodon.com').replace('zjy-gray-pre.glodon.com', 'zjy-pre.glodon.com').replace('zjytest-gray', 'zjytest')
          this.$router.push({
            path: '/iframe/' + encodeURIComponent(iframeUrl) + '/' + encodeURIComponent(menuName),
            query: {
              linkUrl: iframeUrl,
              t: new Date().getTime()
            }
          })
        }
      }
    }
  }
}
</script>
